document.addEventListener('DOMContentLoaded', () => {
  let hiding;
  let hide;

  document.querySelector('.css-typing').addEventListener('click', () => {
    clearTimeout(hiding);
    clearTimeout(hide);
    let landingContainer = document.querySelector('.landing__container')
    let landingText = document.querySelector('.css-typing p')
    landingText.classList.add('hiding')
    landingContainer.classList.add('hiding')
    setTimeout(() => {
      document.body.style = "overflow: visible; height: auto;"
      let header = document.querySelector('.main-header-container')
      let landingContainer = document.querySelector('.landing__container')
      landingContainer.classList.add('hide')
      header.classList.add('sticky')
    }, 1500)
  })

  hiding = setTimeout(() => {
    let landingContainer = document.querySelector('.landing__container')
    let landingText = document.querySelector('.css-typing p')
    landingText.classList.add('hiding')
    landingContainer.classList.add('hiding')
  }, 8500)
  hide = setTimeout(() => {
    document.body.style = "overflow: visible; height: auto;"
    let header = document.querySelector('.main-header-container')
    let landingContainer = document.querySelector('.landing__container')
    landingContainer.classList.add('hide')
    header.classList.add('sticky')
  }, 10000)
})

